import {range as getRange, toNumber, createSelector} from 'vendor';
import {date, today, length} from 'store/common';
import {startOfWeek} from './week';

export const lastDays = createSelector(
  [date, today, length],
  (date, today, length) => getRange(toNumber(length)).map(i => (date ?? today).clone().subtract(i, 'day')).reverse()
);

export const period = createSelector(
  [(_: unknown, ts: number) => ts, (_: unknown, __: unknown, ts: number) => ts],
  (starting_date, target_date) => {
    const result = [];
    if (target_date) {
      let date = starting_date;
      do {
        result.push(date);
        date += 24 * 60 * 60;
      } while (result.length < 365 * 3 && date <= target_date);
    }
    return result;
  },
  {memoizeOptions: {maxSize: 50}}
);

export const reversePeriod = createSelector(
  [period],
  (period) => [...period].reverse(),
  {memoizeOptions: {maxSize: 50}}
);

export const range = createSelector(
  [today, length, startOfWeek, (_: unknown, {position}: {position: number}) => position],
  (today, length, startOfWeek, position) => {
    if (!position) {
      return [
        today.clone().subtract(length - 1, 'day'),
        today
      ];
    } else if (length === '7') {
      return [
        today.clone().add(position, 'week').startOf('week'),
        today.clone().add(position, 'week').endOf('week')
      ];
    }
    return [
      today.clone().add(position, 'month').startOf('month'),
      today.clone().add(position, 'month').endOf('month')
    ];
  },
  {memoizeOptions: {maxSize: 50}}
);
